import React, { useState } from "react"
import { useDispatch } from "react-redux"
import { useHistory } from "react-router-dom"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faSync } from "@fortawesome/free-solid-svg-icons"
import { changePassword } from "../../store/actions/navActions"
import { showToast } from "../../store/actions/toastActions"
import { generalStyles as gs } from "../styles/styles"
import { COLORS } from "../../utilities/Constants"

// Changement de mot de passe volontaire (menu compte de la nav). Le pendant
// forcé à la première connexion vit dans ForcePasswordChange : mêmes règles
// (8 caractères minimum, confirmation identique), même endpoint.
const FIELDS = [
	{ key: "current_password", label: "Mot de passe actuel" },
	{ key: "new_password", label: "Nouveau mot de passe" },
	{ key: "confirm_password", label: "Confirmer le nouveau" },
]

const ChangePasswordPage = () => {
	const dispatch = useDispatch()
	const history = useHistory()
	const [form, setForm] = useState({
		current_password: "",
		new_password: "",
		confirm_password: "",
	})
	const [submitting, setSubmitting] = useState(false)
	const update = (k, v) => setForm((p) => ({ ...p, [k]: v }))

	const invalid =
		!form.current_password ||
		form.new_password.length < 8 ||
		form.new_password !== form.confirm_password

	const submit = () => {
		if (form.new_password !== form.confirm_password) {
			dispatch(
				showToast(
					"warning",
					"Les nouveaux mots de passe ne correspondent pas.",
				),
			)
			return
		}
		if (form.new_password.length < 8) {
			dispatch(showToast("warning", "8 caractères minimum."))
			return
		}
		setSubmitting(true)
		dispatch(changePassword(form)).then((ok) => {
			setSubmitting(false)
			// Le toast de succès est déjà émis par l'action.
			if (ok) history.push("/home")
		})
	}

	return (
		<div
			style={{
				...gs.page,
				display: "flex",
				flexDirection: "column",
				alignItems: "center",
			}}
		>
			<div style={{ ...gs.header, textAlign: "center", display: "block" }}>
				<div style={gs.ficheNumber}>Mon compte</div>
				<h1 style={gs.title}>Changer de mot de passe</h1>
			</div>
			<div style={{ ...gs.card, width: "100%", maxWidth: 520 }}>
				<div style={gs.cardTitle}>Mot de passe</div>
				<div style={gs.fieldGroup}>
					{FIELDS.map((f) => (
						<div key={f.key} style={gs.fieldRow}>
							<label style={gs.label}>{f.label}</label>
							<input
								type="password"
								autoComplete="new-password"
								style={gs.input}
								value={form[f.key]}
								onChange={(e) => update(f.key, e.target.value)}
								onKeyDown={(e) =>
									e.key === "Enter" &&
									!invalid &&
									!submitting &&
									submit()
								}
							/>
						</div>
					))}
				</div>
				<p
					style={{
						fontSize: 12,
						color: COLORS.textLight,
						margin: "14px 0 0",
					}}
				>
					8 caractères minimum.
				</p>
				<div
					style={{
						display: "flex",
						justifyContent: "flex-end",
						gap: 10,
						marginTop: 20,
					}}
				>
					<button
						type="button"
						style={gs.btnSecondary}
						onClick={() => history.goBack()}
					>
						Annuler
					</button>
					<button
						type="button"
						style={invalid || submitting ? gs.btnDisabled : gs.btnPrimary}
						disabled={invalid || submitting}
						onClick={submit}
					>
						{submitting ? <FontAwesomeIcon icon={faSync} spin /> : "Valider"}
					</button>
				</div>
			</div>
		</div>
	)
}

export default ChangePasswordPage
